import { get } from "@/apis";
import message from "ant-design-vue/lib/message";

export default {
  namespaced: true,
  state: {
    ActivityConfigRenderingCompleted: false, // 活动配置是否渲染完成

    GateConfigRenderingCompleted: false, // 门禁配置是否加载完成
    // 活动信息
    activity: {
      id: 0,
      alias: 0,
      activityId: 0,
      beginTime: "",
      endTime: "",
      banner: "",
      footer: "",
      status: "",
    },
  },
  mutations: {
    SET_ACTIVITY(state, payload) {
      state.activity = payload;
    },
    SET_ACTIVITY_CONFIG_RENDERING_COMPLETED(state, payload) {
      state.ActivityConfigRenderingCompleted = payload;
    },
    SET_GATE_RENDERING_COMPLETED(state, payload) {
      state.IsRenderingCompleted = payload;
    },
  },
  getters: {
    getActivity: (state) => {
      return state.activity;
    },
    getActivityConfigRenderingCompleted: (state) => {
      return state.ActivityConfigRenderingCompleted;
    },
  },
  actions: {
    async setActivity(context, data) {
      const { alias } = data;
      const res = await get(`/api/Gate/GetActivityConfig?alias=${alias}`);
      if ((res.code = 200 && res.success)) {
        context.commit("SET_ACTIVITY", res.data);
      }
    },
    setActivityConfigRenderingCompleted(context, data) {
      context.commit("SET_ACTIVITY_CONFIG_RENDERING_COMPLETED", data);
    },
  },
};
